export default __webpack_public_path__ + "static/media/retro-boost.a8d4d7fc.svg";